import { Play } from "lucide-react";
import { Reveal } from "./Reveal";
import { WORK } from "../data";

const WorkCard = ({ item, index }) => (
  <Reveal delay={(index % 2) * 0.1} className={`col-span-1 ${item.span}`}>
    <a
      href={item.href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`work-card-${item.id}`}
      className="work-card group block relative overflow-hidden border border-foreground/10"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img src={item.img} alt={item.title} className="work-media h-full w-full object-cover" />
        <div className="absolute inset-0 bg-background/30 group-hover:bg-background/10 transition-colors duration-500" />
        <span className="absolute top-4 right-4 text-xs uppercase tracking-[0.2em] text-foreground/70">
          {item.year}
        </span>
        {/* Play indicator */}
        <span className="absolute inset-0 grid place-items-center">
          <span className="grid place-items-center h-16 w-16 lg:h-20 lg:w-20 rounded-full bg-background/70 backdrop-blur-sm text-foreground group-hover:bg-primary group-hover:text-primary-foreground group-hover:scale-110 transition-all duration-500">
            <Play size={26} className="translate-x-[2px]" fill="currentColor" />
          </span>
        </span>
      </div>
      <div className="flex items-end justify-between p-5 lg:p-6">
        <div>
          <h3 className="font-display font-bold text-2xl lg:text-3xl tracking-tight group-hover:text-primary transition-colors duration-300">
            {item.title}
          </h3>
          <p className="mt-1 text-xs uppercase tracking-[0.2em] text-foreground/50">{item.cat}</p>
        </div>
        <span className="text-foreground/40 group-hover:text-primary transition-colors duration-300 text-sm uppercase tracking-[0.2em] whitespace-nowrap">
          Watch on Vimeo
        </span>
      </div>
    </a>
  </Reveal>
);

export const Work = () => {
  return (
    <section id="work" data-testid="work-section" className="relative py-16 lg:py-24 px-6 lg:px-12">
      <Reveal className="mb-10 lg:mb-14 flex flex-col lg:flex-row lg:items-end justify-between gap-6">
        <div>
          <p className="inline-block bg-primary text-primary-foreground px-4 py-2 text-xs sm:text-sm uppercase tracking-[0.25em] font-bold">The Showreel</p>
          <h2 className="mt-6 font-display font-extrabold text-5xl sm:text-6xl lg:text-7xl uppercase tracking-tighter leading-[0.9]">
            Watch
            <br />
            the work
          </h2>
        </div>
        <p className="font-body text-base text-foreground/60 max-w-sm lg:text-right">
          Two reels, one studio. Dive into our animation and film work — hover to bring each frame to
          life, click to play on Vimeo.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
        {WORK.map((item, i) => (
          <WorkCard key={item.id} item={item} index={i} />
        ))}
      </div>
    </section>
  );
};
